import AntSwitch, { type SwitchProps as AntSwitchProps } from "antd/lib/switch";
import { FC } from "react";

export type SwitchProps = AntSwitchProps;

export const Switch: FC<SwitchProps> = props => {
    return <AntSwitch {...props} />;
};
